<template>
  <div class="controls-container">
    <LayerControls
      :heat-maps="heatMaps"
      :weather-maps="weatherMaps"
      :weather-map-opacity="weatherMapOpacity"
      :available-features="availableFeatures"
      :regions="regions"
      :hazards="enabledHazards"
      :weather-parameter-info="weatherParameterInfo"
      :open="layerControlState.open"
      :active-heat-map="activeHeatMap"
      :active-particle-layer="activeParticleLayer"
      :active-features="activeFeatures"
      @toggle="toggleLayerControlState()"
      @change="onLayerControlChange($event)"
      @changeparticle="onParticleLayerControlChange($event)"
      @changefeature="onFeatureChange($event)"
      @changeopacity="onOpacityChange"
    >
    </LayerControls>
  </div>
</template>

<script>
  import { reactive } from 'vue'
  import LayerControls from './LayerControls.vue'
  export default {
    components: { LayerControls },
    props: [
      'activeHeatMap',
      'activeParticleLayer',
      'activeFeatures',
      'heatMaps',
      'regions',
      'hazards',
      'sites',
      'weatherMaps',
      'weatherMapOpacity',
      'availableFeatures',
      'weatherParameterInfo'
    ],
    data() {
      return {
        layerControlState: reactive({ open: false }),
        regionControlState: reactive({ open: false }),
        siteControlState: reactive({ open: false }),
        enabledHazards: reactive({})
      }
    },
    watch: {
      hazards: {
        handler(newHazards) {
          if (!newHazards) return;
          const enabled = this.getEnabledHazardsOnly(newHazards);
          Object.assign(this.enabledHazards, enabled);
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      getEnabledHazardsOnly(hazards) {
        if (!hazards || typeof hazards !== 'object') return {};
        const allHazards = JSON.parse(JSON.stringify(hazards));
        for (const [key, value] of Object.entries(allHazards)) {
          if (!allHazards[key].enabled && allHazards[key].hasOwnProperty('enabled')) {
            delete allHazards[key];
          }
        }
        return allHazards;
      },
      toggleLayerControlState() {
        this.layerControlState.open = !this.layerControlState.open;
      },
      onLayerControlChange(event) {
        this.$emit('change', event);
      },
      onParticleLayerControlChange(event) {
        this.$emit('changeparticle', event);
      },
      onFeatureChange(event) {
        this.$emit('changefeature', event);
      },
      onOpacityChange(opacity) {
        this.$emit('updateOpacity', opacity);
      }
    }
  }
</script>
